import { FaCar, FaBus, FaRegClipboard  } from 'react-icons/fa';  // Import icons

const cardInfo = [
    {
      appName: 'Nemt Provider Dashboard',
     // description: 'Access to Nemt Provider Dashboard.',
      redirectTo: '/nemt-provider-dashboard',
      bgColor: "rcBrand.teal",
      icon: <FaBus size={40} color="#023F2E" />  // Adjust icon size and color
    },
    {
      appName: 'Nemt Mileage Reimbursement Dashboard',
     // description: 'NEMT Mileage Reimbursement Dashboard.',
      redirectTo: "/mr-nemt-dashboard",
      bgColor: "rcBrand.olive",
      icon: <FaCar size={40} color="#023F2E" />  // Adjust icon size and color
    },
    {
      appName: 'Credentialing Dashboard',
     // description: 'Access to the Credentialing Dashboard',
      redirectTo: '/credentialing-dashboard',
      bgColor: "rcBrand.sky",
      icon: <FaRegClipboard size={40} color="#023F2E"/>  // Adjust icon size and color
    }
];

export default cardInfo;
